/**
 * Created by Miguel on 23/05/2017
 */
import { Component, OnInit,ChangeDetectionStrategy, ViewEncapsulation  } from '@angular/core';
import { ActivatedRoute,RouterLink,Router} from '@angular/router';

import {FormBuilder, FormGroup} from "@angular/forms";
import { CompanyService }  from '../../services/company.service';
import { AppDataService }  from '../../services/app-data.service';
import { ChartModule }            from 'angular2-highcharts'; 

import {WalletService} from "../../services/wallet.services";
import { RecipeBean } from '../../beansts/recipe.bean';
import { TranslationService } from '../../services/translation.service';

import {UserService} from "../../services/user.service";
import { serializePaths } from '@angular/router/src/url_tree';
import { TransitiveCompileNgModuleMetadata } from '@angular/compiler';
import { THROW_IF_NOT_FOUND } from '@angular/core/src/di/injector';
declare let Swal: any;
declare var $ : any;



@Component({
    changeDetection: ChangeDetectionStrategy.Default,
    encapsulation: ViewEncapsulation.Emulated,
    selector : 'office-component',
    templateUrl:'office.component.html',
    providers  : []
})
export class OfficeComponent implements OnInit {


    public options;
    public workers=[]
    public canEdit=false
    public superCanEdit=false
    public hasCompany;
    public tab=1;
    public subTab=1;
    public rooms=[];
    public tables=[];
    public mainRoom;

    //events
    public uploadImageType;
    public speakers=[];
    public speaker;
    public organizer;
    public activities=[];
    public events=[];
    public event;
    public worker;
    public activity;

    public transactions=[];
    public livecoins;
    public forSale=[
        {
            token: '44k1sFMHWoiysphgYEzt6cTEThSHXNyxJy7uDn2diG23',
            name:'PostIt',
            id:'POSTIT',
            thumbnail:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2FeventRecipepostit.png?alt=media&token=8b3f49ad-544b-4ab4-b4b8-a229697b1ebe',
            cost:0.1,
            quantity:0
        },
        {
            token: '9STz2EWPhh2BN7FUh8o9whbE67mhh3JConP4Wy5rRZ7C',
            name: 'Chave',
            thumbnail:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2FeventRecipeThumbnail%2FeventRecipeThumbnail_1640530071119.png?alt=media&token=30f4f464-3a53-490c-bc42-e0914628b853',
            id:'1640530071119',
            cost:0.1,
            quantity:0
        },
    ]

    public room;
    public table;

    public company;
    public companyName="Indefinido"
    public companyForm : FormGroup;
    public workerForm : FormGroup;
    public roomForm : FormGroup;
    public dateForm : FormGroup;
    public eventForm: FormGroup
    public activityForm : FormGroup;

    public eventIdDisabled=false
    public startDate;
    public endDate;
    public graphUsers;
    

    public graphtab=1;


////////////card variables////////
public processing : boolean=false;
public date: Date = new Date();
public gender='M'
public kind=0;
public settings = {
      bigBanner: true,
      timePicker: false,
      format: 'dd-MM-yyyy',
      defaultOpen: false
}
public brandValue;
public numberMask = [/[0-9]/, /[0-9]/, /[0-9]/,/[0-9]/, '.',/[0-9]/,/[0-9]/,/[0-9]/, /[0-9]/, '.', /[0-9]/, /[0-9]/, /[0-9]/, /[0-9]/, '.',/[0-9]/,/[0-9]/,/[0-9]/, /[0-9]/]
public expirationMask = [ /[0-1]/,/[0-9]/,'/',/[0-2]/,/[0-9]/,/[0-9]/,/[0-9]/]
public cvvMask = [/[0-9]/, /[0-9]/, /[0-9]/]
public  imageStr;

public cardForm : FormGroup;
public canMailChange=true;
public brands=[
  "VISA","MASTER","AMEX","ELO","AURA","DINERS","JCB","DISCOVER","HIPERCARD","HIPER"
]
//////////////////////////////


    constructor(private _routeParams: ActivatedRoute ,
        private _router: Router ,private translate: TranslationService,private _walletService: WalletService,private _companyService : CompanyService, private fb : FormBuilder, public _appData : AppDataService,private _auth : UserService) {
    }

    public setGraphTab(tab){
        this.graphtab=tab
        if (tab==1){
            this.getWorkerGraph(this.room)
        }
        else if (tab==2){
            this.getWorkerGraph(this.room)
        }
        this.subTab=3
        this.tab=3
    }


    public setTab(tab){
        this.tab=tab;
        this.subTab=1;
        if (tab==5){
            //need to get the company wallet
            this._walletService.getWallet('company',this.company.dbId).subscribe(val=>{
                if (val.status==200){
                    this.getWalletContents();
                }
                else{
                    this._walletService.getCreateWallet('company',this.company.dbId).subscribe(val=>{
                        this.getWalletContents();
                    })
                }
              },err=>{
                this._walletService.getCreateWallet('company',this.company.dbId).subscribe(val=>{
                    this.getWalletContents();
                  })
            })
        }
        if (tab==6){
            this.events=[]
            this._companyService.getEventOnApp().where("company","==",this.company.dbId).get().then(v=>{
                v.forEach(element => {
                    this.events.push(element.data());
                });
            })
        }
    }

    public ngOnInit() : any {


        this.cardForm = this.fb.group({
            cardHolderName : '',
            cardNumber : '',
            cardExpiration : '',
            cardCvv: '',
            livecoinQuantity:10
          });

        this.companyForm = this.fb.group({
            name:'',   
            mission:'',
            values:'',
            description:'',   
            attractions: "",
            code: "",
            website: ""                  
          });
          this.workerForm = this.fb.group({
            email:'', 
          });
          this.dateForm = this.fb.group({
            start:'01/04/2022', //
            end:'30/04/2022'  
          })
          this.eventForm = this.fb.group({
            id:'',
            name:'',   
            start:'',
            description:'',   
            attractions: "",
            end: "",
            color:""   
          })
          this.activityForm = this.fb.group({
            name:'',   
            start:'',
            description:'',   
            end: "",
          })
        this.startDate=new Date();
        this.startDate.setMinutes(0)
        this.startDate.setSeconds(0)
        this.startDate.setHours(0)
        this.startDate.setMilliseconds(0)
        this.startDate.setDate(1)
        let time=this.startDate.getTime()
        this.endDate=new Date(time+30*24*60*60*1000)
        this.endDate.setMinutes(0)
        this.endDate.setSeconds(0)
        this.endDate.setHours(0)
        this.endDate.setMilliseconds(0)


          this._routeParams.queryParams.subscribe(params => {
            var id = params['id'];
            var uid = params['uid']
            if (uid=="T6sKpIAzwlPlYmEGgy2FuolQ2wN2") {
                this.canEdit=true;
                this.superCanEdit=true;
            }
             if (uid){
                this._companyService.getUserByUid(uid).then(val=>{
                    let us=val.data();
                    this._appData.instagramUser=us;
                    console.log(us)
                }
               )
            }
            //option for auto-register
              if (id){
                  this.hasCompany=true;
                //COLETA DE USUARIO USANDO O UID VINDO DE FORA
                this._companyService.getCompanyById(id).onSnapshot(snapshot => {
                    if (snapshot) {
                    this.company=snapshot.data();
                    //Vai atras de detalhes do evento
                    this.companyName=this.company.name
                    if (!this.company.workers) this.company.workers=[]
                    this.workers=this.company.workers;
                    let filt=this.workers.filter((us=>{
                        return us.uid==this._appData.instagramUser.uid
                    }))
                    if (filt.length>0){
                        if (filt[0].admin){
                            this.canEdit=true;
                        }
                    }
                    this.companyForm = this.fb.group({
                        name:this.company.name ? this.company.name : "",                 
                        mission:this.company.mission ? this.company.mission : "",
                        values:this.company.values ? this.company.values : "",
                        description:this.company.description ? this.company.description : "",                          
                        attractions:this.company.attractions ? this.company.attractions : "",
                        code:this.company.code ? this.company.code : "",
                        website:this.company.website ? this.company.website : ""                          

                    });
                    this._companyService.getRooms().where('company','==',this.company.dbId).get().then(val=>{
                        this.rooms=[]
                        val.forEach(r=>{
                            this.rooms.push(r.data())
                        })
                    })
                    this.getWalletContents()
                    
                }
                })
              }
              else{
                this.hasCompany=false;
                this.companyForm = this.fb.group({
                    name:"",                 
                    mission:'',
                    values:'',
                    attractions:'',
                    email:'',
                    description:'',
                    code:'',
                    website:''
       
                  });

            } 
            
          });
    }
    public getWalletContents(){
        this._walletService.getTransactions(this.company.dbId,'company').subscribe(val=>{
            this.transactions=val.json();
        });
        this._walletService.getTokenBalance('company',this.company.dbId).subscribe(val=>{
            let vet=val.json();
            let lid=0;
            let nfts=[]
            vet.forEach(element => {
              let address=element.mint_address
              let amount=element.ui_amount
              if (address=='BmHvLKAGRd2o3WKm2U7u7qaJoAjzqCQfzLyUVrFznmuu'){
                  this.livecoins=amount;
              } 
              else if (address=='44k1sFMHWoiysphgYEzt6cTEThSHXNyxJy7uDn2diG23'){
                    this.forSale[0].quantity=amount
              }
              else if (address=='9STz2EWPhh2BN7FUh8o9whbE67mhh3JConP4Wy5rRZ7C'){
                  this.forSale[1].quantity=amount
              }
  
            })
        });
        this.transactions=[]
        this._walletService.getTransactions(this.company.dbId,'company').subscribe(val=>{
          this.transactions=val.json();

        });     

    }

    public gotoRoom(){

    }
    public notifyRoom(){
        let url=    this.roomForm.controls['embed'].value;
      if (!url){
        url=''
      }
      let date=new Date();
      let time=date.getTime();
      let notification={
        subject:'mudança de video',
        video:url,
        kind:'updateRoomVideo',
        room:this.room.id,
        date:time
      }
      this._companyService.addVideoToRoomList(this.room.id,url)
      this._companyService.addEventNotification({id:'1592880902713'},notification)
      this._companyService.getRoom(this.room.id).get().then(val=>{
              let room=val.data();
              room.video=url;
              this._companyService.updateRoom(room);
      })
    }
    
    public saveRoom(){
        let room=this.table;
        if (room==null) {
            room=this.room;
        }
        let name=    this.roomForm.controls['name'].value;
        room.roomName=name;
        this._companyService.getRooms().doc(room.id).set(room);
        Swal.fire('Sala editada','Nome da sala editada com sucesso')
        this.setTabParameter(1,'','')

    }
    public tradeForLivecoins(transaction){
        Swal.fire({
            title: 'Aguarde',
            text: 'Sua compra está sendo processada. Aguarde.',
            imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
            showConfirmButton: false
        })
        this._walletService.transactionToLivecoin(transaction,'company').subscribe(val=>{
          Swal.fire(this.translate.instant('SUCCESS'),"Sua transação virou livecoins")
          this.getWalletContents();
        },err=>{
            Swal.fire(this.translate.instant('FAIL'),"Rede congestionada")

        })
      }
    public addStaticRoom(){
        Swal.fire({title:'Você deseja adicionar uma sala estática?',text:'Salas estáticas servem para serem salas de reunião ou mesas de trabalho de colaborador. Primeiro você vai criar a mesa nova com nome e imagem padrão. Depois você pode editar o nome da mesa e a imagem. Por fim, você poderá conectar essa mesa a um objeto vazio em sua sala.'
        ,showCloseButton: true,
        confirmButtonText: 'Sim',
        preConfirm: () => {
            let found=false;
            let date=new Date();
            let milis=date.getTime();
            let room={
                characterScale:1,
                event:            "1592880902713",
                father:            this.room.id,
                gamepath:            "",
                id:                 milis.toString(),
                jitsiServer:           "",
                name:            "empty",
                noWalk:            true,
                nonisometric:            true,
                roomName:            "Sala estática",
                shift:{
                    x:                -0.05,
                    y:                -0.05
        
                },
                template:            false,
                textures:{
                            background:            "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2FroomBackground%2FroomBackgroundmes%20areuniao.png?alt=media&token=f360a66b-a4bb-4d4a-b164-6d6497c06adc"
                },
                tileSize:            16
            }
            this._companyService.getRooms().doc(room.id).set(room);
            this.tables.push(room)
            Swal.fire(this.translate.instant('SUCCESS'),"Sua nova sala estática foi criada. Agora você pode editar o nome e a imagem dela.")
        }
      });   
    }
    public addRoom(){
        Swal.fire({title:'Você deseja adicionar uma sala?',text:'Salas novas podem ser adicionados apenas pelo superusuario.'
        ,showCloseButton: true,
        confirmButtonText: 'Sim',
        preConfirm: () => {
            let found=false;
            let date=new Date();
            let milis=date.getTime();
            let room={
                characterScale:2,
                tileMap:"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Fmaps%2Finovateca-1andar.js?alt=media&token=4f67d764-715f-4115-beb2-dd371d666b9c",
                defaulPlace:{
                    x:15,
                    y:18
                },
                company:this.company.dbId,
                event:            "1592880902713",
                gamepath:            "wss://viplista.com.br/ws/",
                id:                 milis.toString(),
                jitsiServer:           "viplistas.com.br",
                name:            "empty",
                roomName:            "Sala",
                shift:{
                    x:                -0.05,
                    y:                -0.05       
                },
                scale:{
                    x:                1,
                    y:                1
                },
                template:            false,
                textures:{
                            background:            "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2FroomBackground%2FroomBackgroundmes%20areuniao.png?alt=media&token=f360a66b-a4bb-4d4a-b164-6d6497c06adc",
                            collisionTile:{
                                cols:1,
                                rows:1,
                                path:"https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2Ftilesets%2Fcollision.png?alt=media&token=f11dfdb0-c25d-415b-ae50-d1c791a6264c"
                            }
                },
                video:""
            }
            this._companyService.getRooms().doc(room.id).set(room);
            this.tables.push(room)
            Swal.fire(this.translate.instant('SUCCESS'),"Sua nova sala estática foi criada. Agora você pode editar o nome e a imagem dela.")
        }
      });   
    }

/**
 *  Initializes the API client library and sets up sign-in state
 *  listeners.
 */
    public setTabParameter(subtab,code,param){
        this.subTab=subtab
        if (code=='roomTables'){
            this.room=param;
            this._companyService.getRooms().where('father','==',param.id).get().then(val=>{
                this.tables=[]
                val.forEach(r=>{
                    let room=r.data();
                    if (room.noWalk){
                        this.tables.push(r.data())
                    }
                })
            })
        }
        else if (code=='roomGraph'){
            this.getWorkerGraph(param);     
        }
        else if (code=='editRoom'){
            this.room=param;
            this.roomForm = this.fb.group({
                name:param.roomName,    
                embed:param.video               
              });
        }
        else if (code=='editTable'){
            this.table=param;
            this.roomForm = this.fb.group({
                name:param.roomName,    
                embed:param.video                     
              });
        }

        else{
            this.room=null;
            this.table=null;
        }

    }
    public updateDates(){
        var dataExclusao =   this.dateForm.controls['start'].value;
        var arrDataExclusao = dataExclusao.split('/');
        var stringFormatada = arrDataExclusao[1] + '-' + arrDataExclusao[0] + '-' +  arrDataExclusao[2];
        this.startDate = new Date(stringFormatada);

        dataExclusao =   this.dateForm.controls['end'].value;
        arrDataExclusao = dataExclusao.split('/');
        stringFormatada = arrDataExclusao[1] + '-' + arrDataExclusao[0] + '-' +  arrDataExclusao[2];
        this.endDate = new Date(stringFormatada);

        this.getWorkerGraph(this.room)
    }
    public getWorkerGraph(param){
        let series=[]
        this.room=param;
        this._companyService.getRoomUserDailyPresence(param.id).once("value", (data) =>{
            //each record is a user
            let report=data.val();


            let users={};

            let start=this.startDate;
            let end=this.endDate;

            if (report){
                for (let uskey in report) {
                    let filter;
                    filter=this.workers.filter((val)=>{
                            return val.uid==uskey
                    })
                    if (filter.length>0 && this.graphtab==1){
                            //user is a worker
                            users[uskey]={
                                full_name:filter[0].full_name,
                                hours:0,
                                profile_picture:filter[0].profile_picture
                            }
                            let days=report[uskey]
                            let vdata=[]
                            let novoStart=this.startDate;
                            novoStart.setMinutes(0)
                            novoStart.setSeconds(0)
                            novoStart.setHours(0)
                            novoStart.setMilliseconds(0)
                            let startMilis=novoStart.getTime();
                            let endMilis=this.endDate.getTime();
                            let daypassed=24*60*60*1000
                            for (let day=startMilis; day<endMilis; day=day+daypassed){
                                let mils=day;
                                if (days[mils]){
                                    vdata.push((days[mils].duration/60))
                                    users[uskey].hours=users[uskey].hours+(days[mils].duration/60)
                                }
                                else{
                                    vdata.push(0)
                                }
                            }
                            let us=filter[0]
                            series.push({name:us.full_name,data:vdata})
    
                    }                   
                    else if (filter.length==0 && this.graphtab==2) {
                                                    //user is not a worker
                                                    let days=report[uskey]
                                                    let vdata=[]
                                                    let novoStart=new Date();
                                                    novoStart.setMinutes(0)
                                                    novoStart.setSeconds(0)
                                                    novoStart.setHours(0)
                                                    novoStart.setMilliseconds(0)
                                                    novoStart.setDate(1)
                            
                                                    for (let day=1; day<31; day++){
                                                        novoStart.setDate(day);
                                                        let mils=novoStart.getTime();
                                                        if (days[mils]){
                                                            vdata.push((days[mils].duration/60))
                                                        }
                                                        else{
                                                            vdata.push(0)
                                                        }
                                                    }
                                                    let us={full_name:'Visitante'}
                                                    series.push({name:us.full_name,data:vdata})

                    }
                };
            }
            else{
                this._companyService.roomUserDailyPresence(param.id)
                this.getWorkerGraph(param)
            }
            this.graphUsers=[]
            for (let prop in users){
                this.graphUsers.push(users[prop])
            }
            this.graphUsers.sort((a, b) =>{ 
                if (a.hours > b.hours) {
                    return -1;
                  }
                  if (a.hours < b.hours) {
                    return 1;
                  }
                  // a must be equal to b
                  return 0;
            })
            this.options = {
                title : { text : 'Presença na Sala' },
                chart: { zoomType: 'x'},
                series: series,
                xAxis: {
                    title: {
                      text: 'Dias'
                    },
                  },
                  yAxis: {
                    title: {
                      text: 'Horas'
                    },
                    labels: {
                      format: '{value}'
                    },
                    accessibility: {
                      rangeDescription: 'Range: -90°C to 20°C.'
                    },
                  },
            };
            this._companyService.roomUserDailyPresence(param.id)
        })

    }
    public addWorker(){
        let mail=this.workerForm.controls['email'].value;
        
        this._companyService.getUsersByEmail(mail).then(val=>{
            let us=null
            val.forEach(mail=>{
                us=mail.data();
            })

            if (!us){
                Swal.fire({title:'Email não encontrado',text:'Digite um novo email e tente novamente'})
            }
            else{
                Swal.fire({title:'Email encontrado',text:'O nome do seu colaborador é '+us.full_name+'?'
                ,showCloseButton: true,
                confirmButtonText: 'Sim',
                preConfirm: () => {
                    let found=false;
                    if (this.workers.length>0){
                        for (let i=0;i<this.workers.length;i++) {
                            if (this.workers[i].uid==us.uid){
                                this.workers[i]=us;
                                found=true;
                            }
                        }
                        if (!found){
                            this.workers.push(us);
                        }       
                    }
                    else{
                        this.workers.push(us);   
                    }
                    this.saveCompany();                               
                }
              });   

            }
        })

    }   

    public downloadImage(){

    }
    public uploadImage(type){
        this.uploadImageType=type
        $('#backgroundAdd').click();
    }
    public finishUploadSave(fileInput: any){
        let obj=null;
        let id="";
        if (this.table) {
            obj=this.table
            id=obj.id;
        }
        else if (this.room) {
            obj=this.room
            id=obj.id
        }
      var file = fileInput.target.files[0];
      let date=new Date();
      let newfile = id.toString()+'_'+date.getTime()+'.png';
      this._auth.uploadToFirebase(file, newfile, 'companies/'+this.company.dbId+'/background/').subscribe(snapshot =>{
        snapshot.ref.getDownloadURL().then(url => {
          console.log(url);
          if (this.uploadImageType){
            switch (this.uploadImageType){
                case 'eventBackground':{
                    this.event.background=url;
                    this._companyService.getEventOnApp().doc(this.event.id).set(this.event);
                    break;
                }
                case 'eventIcon':{
                    this.event.icon=url;
                    this._companyService.getEventOnApp().doc(this.event.id).set(this.event);
                    break;
                }
                case 'activityBackground':{
                    this.activity.background=url;
                    this._companyService.getEventOnApp().doc(this.activity.id).set(this.activity);
                    break;
                }
            }
          }
          else{
            if (obj){
                obj.textures.background=url;
                this._companyService.getRoom(obj.id).set(obj).then((val)=>{
                    let obj=this.table;
                    if (this.table) {
                        this.table.textures.background=url
                    }
                    else if (this.room) {
                        this.room.textures.background=url
                    }
            
                })    
            }
            let array=this.company.background
            if (!array) array=[]
            array.push(url)
            this.company.background=array;
            this._companyService.getCompanyById(this.company.dbId).set(this.company)
            }
        })
  
      });
    }
    public selectTexture(texture){
        if (this.canEdit){
            Swal.fire({
                title:"Escolha de textura",
                imageUrl: texture,
                imageWidth: 400,
                imageHeight: 200,
                showCancelButton: true,
                confirmButtonText: 'fundo da sala',
                cancelButtonText: 'fundo da tela',
                text:'Escolha se vai querer botar essa textura no fundo da sala ou se for na sala de reunião, no fundo da tela.'
            }).then((result) => {
                let obj=null;
                let id="";
                if (this.table) {
                    obj=this.table
                    id=obj.id;
                }
                else if (this.room) {
                    obj=this.room
                    id=obj.id
                }
                if (result.dismiss=='backdrop') {}
                else if (result.dismiss=='close') {}
                else if (result.dismiss=='cancel'){
                    obj.textures.meetingBackground=texture;
                    this._companyService.getRoom(obj.id).set(obj).then((val)=>{
                      })    
                  //sair
                }
                else if (result.value) {
    
                    obj.textures.background=texture;
                        this._companyService.getRoom(obj.id).set(obj).then((val)=>{
                            if (this.table) {
                                this.table.textures.background=texture
                            }
                            else if (this.room) {
                                this.room.textures.background=texture
                            }
                    
                          })    
                }
              }
    
            )
    
        }
        else{
            Swal.fire("Sem permissão","Você não tem permissão de alterar as imagens de fundo.")
        }
    }
    public buyItem(item){
        Swal.fire({title:"Quantos livecoins você pretende usar para comprar "+item.name+"?",
            input: 'number',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Comprar',
            showLoaderOnConfirm: true,
            preConfirm: (name) => {
                if (name){
                    let number=parseInt(name);
                    if (number){
                        if (number<0){
                            Swal.fire("Erro","Precisa ser um número positivo")
                            return;
                        }
                        if (number>this.livecoins){
                            Swal.fire("Erro","Você não tem livecoins suficiente. Compre mais")
                            return;
                        }

                            Swal.fire({
                                title: 'Aguarde',
                                text: 'Sua compra está sendo processada. Aguarde.',
                                imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
                                showConfirmButton: false
                              })
              
                            this._walletService.makePurchaseTransfer('1592880902713','event',this.company.dbId,'company',item.token,10*number,null,null,null,null,null,1*number).subscribe(wa=>{
                                Swal.close()
                                Swal.fire(this.translate.instant('SUCCESS'),'Voce adquiriu novos itens para a empresa')
                                this.getWalletContents();
                              },err=>{
                                Swal.close()
                                Swal.fire(this.translate.instant('FAIL'),'Ouve uma falha na criação do token para sua carteira. Tente de novo')
                          
                              })
    


                    }
                    else{
                        Swal.fire("Erro","Precisa ser um número")
                    }
               }
            }
        })
    }

    public transferItensToWorker(worker){
        Swal.fire({
            title: 'Selecione o token que você deseja transferir',
            input: 'select',
            inputOptions: {
              '1': 'Livecoin',
              '2': 'Postit',
              '3': 'Chave'
            },
            inputPlaceholder: 'required',
            showCancelButton: true,
          }).then( (result) => {
            if (result.value=="1") {
                this.transferToken(worker,'BmHvLKAGRd2o3WKm2U7u7qaJoAjzqCQfzLyUVrFznmuu');
            }
            if (result.value=="2") {
               this.transferToken(worker,'44k1sFMHWoiysphgYEzt6cTEThSHXNyxJy7uDn2diG23');
            }
            if (result.value=="3") {
                this.transferToken(worker,'9STz2EWPhh2BN7FUh8o9whbE67mhh3JConP4Wy5rRZ7C');
            }
    
        });
    }


    public transferToken(worker,token){
        let item=null
        if (token=='BmHvLKAGRd2o3WKm2U7u7qaJoAjzqCQfzLyUVrFznmuu'){
            item={
                name:`livecoin`,
                token:'BmHvLKAGRd2o3WKm2U7u7qaJoAjzqCQfzLyUVrFznmuu',
                id:'livecoin',
                thumbnail:'https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/events%2F1592880902713%2FeventRecipepostit.png?alt=media&token=8b3f49ad-544b-4ab4-b4b8-a229697b1ebe',
                cost:1,
                quantity:this.livecoins
            }
        } else{
            let itemvet =this.forSale.filter(v=>{
                return token==v.token;
            })
            item=itemvet[0]
    
        }
        Swal.fire({title:"Quantos "+item.name+" você pretende transferir para "+worker.full_name+"?",
            input: 'number',
            inputAttributes: {
                autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'Comprar',
            showLoaderOnConfirm: true,
            preConfirm: (name) => {
                if (name){
                    let number=parseInt(name);
                    Swal.fire({
                        title: 'Aguarde',
                        text: 'Transferência está sendo processada. Aguarde.',
                        imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
                        showConfirmButton: false
                    })
            
                    if (number){
                        if (number<0){
                            Swal.fire("Erro","Precisa ser um número positivo")
                            return;
                        }
                        if (number>item.quantity){
                            Swal.fire("Erro","Você não tem suficiente para a transferência. Compre mais")
                            return;
                        }
                        else{
                            if (token=='BmHvLKAGRd2o3WKm2U7u7qaJoAjzqCQfzLyUVrFznmuu'){
                                this._walletService.makeTokenTransfer(this.company.dbId,'company',worker.uid,'user',item.token,number,null,null,null,null,null).subscribe(wa=>{
                                    Swal.close()
                                    Swal.fire(this.translate.instant('SUCCESS'),'Voce tranferiu novos itens para o funcionário')
                                    this.getWalletContents();
                                },err=>{
                                    Swal.close()
                                    Swal.fire(this.translate.instant('FAIL'),'Ouve uma falha na transferência do token para a carteira. Tente de novo')                         
                                })
                            }
                            else{
                                this._companyService.getRecipesRef({id:"1592880902713"}).doc(item.id).get().then(rec=>{
                                    let recipe=new RecipeBean();
                                    recipe.parse(rec.data())                           
                                    let baseItem=recipe.toItem();
                                    //make transfer
                                    this._walletService.makeTokenTransfer(this.company.dbId,'company',worker.uid,'user',item.token,number,baseItem,null,null,worker.uid,'user-container').subscribe(wa=>{
                                        Swal.close()
                                        Swal.fire(this.translate.instant('SUCCESS'),'Voce tranferiu novos itens para o funcionário')
                                        this.getWalletContents();
                                    },err=>{
                                        Swal.close()
                                        Swal.fire(this.translate.instant('FAIL'),'Ouve uma falha na transferência do token para a carteira. Tente de novo')                         
                                    })
                                })
                            }
                        }
                    }
                }
            }
        })
    }


    public selectUserKind(kind,id){
        let k=kind;
//        id=id-1;
        this.workers[id].kind=kind;
        this.company.workers=this.workers;
/*
let found=false;
        for (let i=0;i<this.workers.length;i++) {
            if (this.workers[i].uid==this._appData.instagramUser.uid){
                this.workers[i]=this._appData.instagramUser;
                this.workers[i].kind=kind;
                found=true;
            }
        }
        if (found){*/
            this.saveCompany();
//        }

    }
    public editWorker(worker){
        let found=false;
        for (let i=0;i<this.workers.length;i++) {
            if (this.workers[i].uid==this._appData.instagramUser.uid){
                this.workers[i]=this._appData.instagramUser;
                found=true;
            }
        }
        if (found){
            this.saveCompany();
        }

    }   
    public removeWorker(worker){
        let found=false;
        this.workers=this.workers.filter((it)=>{
            return (this._appData.instagramUser.uid!=it.uId)
          }) 
        this.saveCompany();

    }   
    public saveCompany(){
        let name=this.companyForm.controls['name'].value;
        let description=this.companyForm.controls['description'].value;
        let attractions=this.companyForm.controls['attractions'].value;
        let website=this.companyForm.controls['website'].value;
        let code=this.companyForm.controls['code'].value;

        let mission=this.companyForm.controls['mission'].value;
        let values=this.companyForm.controls['values'].value;

        this.company.name=name;
        this.company.code=code
        this.company.attractions=attractions;
        this.company.website=website;
        this.company.site=website;
        this.company.values=values;
        this.company.mission=mission;
        this.company.description=description;
        this.company.workers=this.workers;
        this._companyService.getCompanyById(this.company.dbId).set(this.company)
        Swal.fire({title:'Dados salvos',text:'Dados de empresa salvos'})
    }
        

    public copyRoom(oldroom){
        Swal.fire({
            title:"Copiar sala",
            imageWidth: 400,
            imageHeight: 200,
            showCancelButton: true,
            confirmButtonText: 'Sim',
            cancelButtonText: 'Não',
            text:'Tem certeza que deseja copiar essa sala?'
        }).then((result) => {
            if (result.dismiss=='backdrop') {}
            else if (result.dismiss=='close') {}
            else if (result.dismiss=='cancel'){}
            else if (result.value) {
                let dt=new Date();
                let tm=dt.getTime()
                let room=JSON.parse(JSON.stringify(oldroom));
                room.id=tm.toString();
                room.template=false;
                if (room.roomObjects){
                  for (let i=0;i<room.roomObjects.length;i++){
                    let newobject=JSON.parse(JSON.stringify(room.roomObjects[i]));
                    let date=new Date();
                    let time = date.getTime()+i;
                    newobject.objectId=time;
                    newobject.room=room.id;
                    //if the room object is linked with another room I need to create a new room for that
                    if (newobject.param){
                        newobject.param.objectId=time;
                    }
                    room.roomObjects[i]=newobject       
                  }
                }
                this._companyService.updateRoom(room)
        
            }
        });

    }
    public makePurchase() : void {
        this.processing = true;
        let form=this.cardForm;
       // if (window.innerWidth<window.innerHeight){
         // form=this.basicMobileInfoForm;
        //}
    
        let number : string      = form.controls['cardNumber'].value;
        let holder : string      = form.controls['cardHolderName'].value;
        let cvv : string = form.controls['cardCvv'].value;
        let expiration:string  =form.controls['cardExpiration'].value;
        let quantity:number = form.controls['livecoinQuantity'].value;
  
  
        if (!holder || holder.length==0){
          Swal.fire({
            title: this.translate.instant('FAIL'),
            text: "Por favor preencha o nome conforme presente no cartão.",
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
          return;
  
        }
        if (!number || number.length==0){
          Swal.fire({
            title: this.translate.instant('FAIL'),
            text: "Por favor preencha o número do cartão.",
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
          return;
  
        }
        if (!cvv || cvv.length==0){
          Swal.fire({
            title: this.translate.instant('FAIL'),
            text: "Por favor preencha o cvv do cartão.",
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
          return;
        }
        if (!expiration || expiration.length==0){
          Swal.fire({
            title: this.translate.instant('FAIL'),
            text: "Por favor preencha a validade do cartão.",
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
          return;
        }
        if (quantity<10){
          Swal.fire({
            title: this.translate.instant('FAIL'),
            text: "O valor mínimo de compra é 10 livecoins, equivalente a 1 real.",
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'OK'
          })
          return;
        }
        if (!this.brandValue) this.brandValue='Visa'
  
        number=number.substring(0,4)+number.substring(5,9)+number.substring(10,14)+number.substring(15,19)
        Swal.fire({
                  title: 'Aguarde',
                  text: 'Sua compra está sendo processada. Aguarde.',
                  imageUrl: "https://firebasestorage.googleapis.com/v0/b/coolkids-669fa.appspot.com/o/gameImages%2Ftransfer.gif?alt=media&token=67c0bdef-76b4-40e5-8fdb-65501ef94aff",
                  showConfirmButton: false
        })
        this._walletService.buyLivecoinsSpec( number, holder, cvv , expiration,this.brandValue, quantity,this.company.dbId,'company').subscribe(res=>{
          if (res.status==200){         
              let result=res.json();
              let transaction=result.result;
              this._walletService.transactionToLivecoin(transaction,'company').subscribe(v=>{
                if (res.status==200){         
                    Swal.fire({title:this.translate.instant('SUCCESS'),text:"Seus livecoins foram comprados com sucesso e foram adicionados a sua wallet."}) 
                }
                else{
                    Swal.fire({title:this.translate.instant('FAIL'),text:"Ocorreu uma falha ao processar o dinheiro em livecoin mas sua transação está gravada e você pode tentar novamente."})
                }
                this.getWalletContents();   
              },err=>{
                Swal.fire({title:this.translate.instant('FAIL'),text:"Ocorreu uma falha ao processar o dinheiro em livecoin mas sua transação está gravada e você pode tentar novamente."})
                this.getWalletContents();   
              })
          }
          else{
            //put item back so others can get it
            Swal.fire({title:this.translate.instant('FAIL'),text:"Ocorreu uma falha ao processar seu cartão de crédito. Verifique com seu banco o que pode estar impedindo o procedimento."})
          }
          $('#cardModal').modal('hide')
        }
        ,err =>{
          $('#cardModal').modal('hide')
          Swal.fire({title:this.translate.instant('FAIL'),text:"Ocorreu uma falha ao processar seu cartão de crédito. Verifique com seu banco o que pode estar impedindo o procedimento."})
        })
  
  
  
    }

    ///////////////////////////////events//////////////////////////
    public longToDate(number){
        let date=new Date(number)
        let day=date.getDate();
        let month=date.getMonth()+1;
        let monthStr=month.toString();
        if (monthStr.length==1) monthStr='0'+monthStr;
        let year=date.getFullYear();
        let hour=date.getHours();
        let hourStr=hour.toString();
        if (hourStr.length==1) hourStr='0'+hourStr;
        let minute=date.getMinutes()
        let minuteStr=minute.toString();
        if (minuteStr.length==1) minuteStr='0'+minuteStr;

        return day+'/'+monthStr+'/'+year+' '+hourStr+':'+minuteStr
    }
    public stringToMilis(str){
        var arrDataExclusao = str.split('/');
        var split2=arrDataExclusao[2].split(' ')
        var split3=split2[1].split(':')
        var stringFormatada = arrDataExclusao[1] + '-' + arrDataExclusao[0] + '-' + split2[0];
        let date = new Date(stringFormatada);
        date.setHours(split3[0])
        date.setMinutes(split3[1])
        return date.getTime();
    }
    public editEvent(ev){
        this.event=ev;
        let startDate=this.longToDate(ev.start)
        let endDate=this.longToDate(ev.end)
        this.eventForm=  this.fb.group({
            id:ev.id,
            name:ev.name,   
            start:startDate,
            description:ev.description,   
            attractions: ev.attractions,
            end: endDate,
            color:ev.color   ? ev.color : '#ffffff'
          })
          this.eventIdDisabled=true;

          this.activities=[]
        this._companyService.getEventOnApp().where('father','==',ev.id).get().then(v=>{
            v.forEach(t=>{
                this.activities.push(t.data());
            })
        })
        this.subTab=4
    }
    public addEvent(){
        let date=new Date();
        let milis=date.getTime();
        this.event={
            name:'',
            id:'',
            start:milis,
            description:'',
            attractions:'',
            end:milis,
            color:'#ffffff',
            speakers:[],
            organizers:[]
        };
        this.eventIdDisabled=false;
        this.activities=[];
        let ev=this.event;
        let startDate=this.longToDate(ev.start)
        let endDate=this.longToDate(ev.end)
        this.eventForm=  this.fb.group({
            id:ev.id,
            name:ev.name,   
            start:startDate,
            description:ev.description,   
            attractions: ev.attractions,
            end: endDate,
            color:ev.color   ? ev.color : '#ffffff'
          })
        this.subTab=4

    }
    public removeSpeaker(worker,kind){
        let found=false;
        this.event[kind]=this.event[kind].filter((it)=>{
            return (worker.uid!=it.uid)
          }) 
          this._companyService.getEventOnApp().doc(this.event.id).set(this.event);                               
    }
    public removeEventRoom(worker){
        let found=false;
        let kind='rooms'
        this.event[kind]=this.event[kind].filter((it)=>{
            return (worker.id!=it.id)
          }) 
          this._companyService.getEventOnApp().doc(this.event.id).set(this.event);                               
    }
    public addSpeaker(param){
        let mail=this.workerForm.controls['email'].value;
        
        this._companyService.getUsersByEmail(mail).then(val=>{
            let us=null
            val.forEach(mail=>{
                us=mail.data();
            })

            if (!us){
                Swal.fire({title:'Email não encontrado',text:'Digite um novo email e tente novamente'})
            }
            else{
                Swal.fire({title:'Email encontrado',text:'O nome da pessoa que você busca é '+us.full_name+'?'
                ,showCloseButton: true,
                confirmButtonText: 'Sim',
                preConfirm: () => {
                    let found=false;
                    if (!this.event[param]) this.event[param]=[];
                    if (this.event[param].length>0){
                        for (let i=0;i<this.event[param].length;i++) {
                            if (this.event[param][i].uid==us.uid){
                                this.event[param][i]=us;
                                found=true;
                            }
                        }
                        if (!found){
                            this.event[param].push(us);
                        }       
                    }
                    else{
                        this.event[param].push(us);   
                    }
                    this._companyService.getEventOnApp().doc(this.event.id).set(this.event);                               
                }
              });   

            }
        })
        
    }
    public addActivity(activity){
            if (activity){
                this.activity=activity
            }
            else{
                //create
                let date=new Date();
                let milis=date.getTime();
                this.activity={
                    name:'',
                    id:milis.toString(),
                    description:'',
                    start:this.event.start,
                    end:this.event.end,
                    father:this.event.id,
                    organizer:[],
                    speaker:[],
                    rooms:[]
                }

            }
            let startDate=this.longToDate(this.activity.start)
            let endDate=this.longToDate(this.activity.end)
            this.activityForm=  this.fb.group({
                name:this.activity.name,   
                start:startDate,
                description:this.activity.description,   
                end: endDate
            })
            setTimeout(()=>{
                $('#activityModal').modal('show')
            },1000)
    }
    public saveActivity(){
        this.activity.name      = this.activityForm.controls['name'].value;
        this.activity.description      = this.activityForm.controls['description'].value;
        let start:string  =this.activityForm.controls['start'].value;
        let end:string = this.activityForm.controls['end'].value;
        this.activity.start=this.stringToMilis(start)
        this.activity.end=this.stringToMilis(end)
        this._companyService.getEventOnApp().doc(this.activity.id).set(this.activity);        
        this.activities=[]
        this._companyService.getEventOnApp().where("father","==",this.event.id).get().then(v=>{
            v.forEach(e=>{
                this.activities.push(e.data())
            })
        })                       
    }
    public saveEvent(){
        this.event.id      = this.eventForm.controls['id'].value;
        this.event.name      = this.eventForm.controls['name'].value;
        this.event.description      = this.eventForm.controls['description'].value;
        this.event.attractions = this.eventForm.controls['attractions'].value;
        let start:string  =this.eventForm.controls['start'].value;
        let end:string = this.eventForm.controls['end'].value;
        this.event.color = this.eventForm.controls['color'].value;
        this.event.start=this.stringToMilis(start)
        this.event.end=this.stringToMilis(end)
        this.event.company=this.company.dbId;
        if (!this.eventIdDisabled){
            this._companyService.getEventOnApp().doc(this.event.id).get().then(v=>{
                if (v.data()){
                    Swal.fire("Id utilizado","Selecione outro identificador para seu evento")
                }
                else{
                    this._companyService.getEventOnApp().doc(this.event.id).set(this.event);     
                    this.eventIdDisabled=true;                          
                    Swal.fire("Evento salvo","Evento salvo no nosso banco de dados")
    
                }
            });                                  
        }
        else{
            this._companyService.getEventOnApp().doc(this.event.id).set(this.event);     
            this.eventIdDisabled=true;                          
            Swal.fire("Evento salvo","Evento salvo no nosso banco de dados")
        }

    }
    public changeSpeaker(speakeruid,kind){
        let v=this.event[kind].filter(t=>{
            return t.uid==speakeruid
        })
        this.speaker=v[0];
    }
    public changeRoom(room){
        let v=this.rooms.filter(t=>{
            return t.id==room
        })
        this.room=v[0];
    }

    public addActivitySpeaker(param){
        let found=false;
                    if (!this.activity[param]) this.activity[param]=[];
                    if (this.activity[param].length>0){
                        for (let i=0;i<this.activity[param].length;i++) {
                            if (this.activity[param][i].uid==this.speaker.uid){
                                this.activity[param][i]=this.speaker;
                                found=true;
                            }
                        }
                        if (!found){
                            this.activity[param].push(this.speaker);
                        }       
                    }
                    else{
                        this.activity[param].push(this.speaker);   
                    }
                    this._companyService.getEventOnApp().doc(this.activity.id).set(this.activity);                               
                    this._companyService.getEventOnApp().where("father","==",this.event.id).get().then(v=>{
                        this.activities=[]
                        v.forEach(e=>{
                            this.activities.push(e.data())
                        })
                    })           
    }
    public addActivityRoom(){
        let found=false;
        let param='rooms';
                    if (!this.activity[param]) this.activity[param]=[];
                    if (this.activity[param].length>0){
                        for (let i=0;i<this.activity[param].length;i++) {
                            if (this.activity[param][i].id==this.room.id){
                                this.activity[param][i]=this.room;
                                found=true;
                            }
                        }
                        if (!found){
                            this.activity[param].push(this.room);
                        }       
                    }
                    else{
                        this.activity[param].push(this.room);   
                    }
                    this._companyService.getEventOnApp().doc(this.activity.id).set(this.activity);                               
                    this._companyService.getEventOnApp().where("father","==",this.event.id).get().then(v=>{
                        this.activities=[]
                        v.forEach(e=>{
                            this.activities.push(e.data())
                        })
                    })           

    }
    public addEventRoom(){
        let found=false;
        let param='rooms';
                    if (!this.event[param]) this.event[param]=[];
                    if (this.event[param].length>0){
                        for (let i=0;i<this.event[param].length;i++) {
                            if (this.event[param][i].id==this.room.id){
                                this.event[param][i]=this.room;
                                found=true;
                            }
                        }
                        if (!found){
                            this.event[param].push(this.room);
                        }       
                    }
                    else{
                        this.event[param].push(this.room);   
                    }
                    this._companyService.getEventOnApp().doc(this.event.id).set(this.event);                                        

    }    
    public removeActivitySpeaker(worker,kind){
        let found=false;
        this.activity[kind]=this.activity[kind].filter((it)=>{
            return (worker.uid!=it.uid)
          }) 
          this._companyService.getEventOnApp().doc(this.activity.id).set(this.activity); 
          this._companyService.getEventOnApp().where("father","==",this.event.id).get().then(v=>{
            this.activities=[]
            v.forEach(e=>{
                this.activities.push(e.data())
            })
        })           
    }
    public removeActivityRoom(worker){
        let found=false;
        let kind='rooms'
        this.activity[kind]=this.activity[kind].filter((it)=>{
            return (worker.id!=it.id)
          }) 
          this._companyService.getEventOnApp().doc(this.activity.id).set(this.activity); 
          this._companyService.getEventOnApp().where("father","==",this.event.id).get().then(v=>{
            this.activities=[]
            v.forEach(e=>{
                this.activities.push(e.data())
            })
        })           
    }

    public gotoEvent(){
        let domain=window.location.origin
        window.location.href=domain+"/eventdashboard/1592880902713?evt="+this.event.id;
    }

    public notify(group){
        Swal.fire({
            title: 'Notificação',
            text:'Escreva uma mensagem para notificar o grupo de usuários',
            input: 'text',
            inputAttributes: {
            autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'OK',
            showLoaderOnConfirm: true,
          }).then((result) => {
          if (result.value) {
                this.event[group].forEach(us=>{
                    this._companyService.sendNotificationToSomeoneElse(this.event,us,{uid:this._appData.instagramUser.uid,full_name:this._appData.instagramUser.full_name},'Notificação',result.value,'text','success',true)
                })
          }
        })
    }
    public notifyUser(user){
        Swal.fire({
            title: 'Notificação',
            text:'Escreva uma mensagem para notificar '+user.full_name+'.',
            input: 'text',
            inputAttributes: {
            autocapitalize: 'off'
            },
            showCancelButton: true,
            confirmButtonText: 'OK',
            showLoaderOnConfirm: true,
          }).then((result) => {
          if (result.value) {
            let video=false;
            let text=result.value;
            if (text.indexOf('https')==0){
              video=true;
            }
            let notification;
            let date=new Date();
            let time=date.getTime();
            if (!video){
              notification={
                subject:'Notificação',
                message:text,
                kind:'text',
                date:time
              }
            }else{
              notification={
                subject:'Notificação',
                video:text,
                kind:'video',
                date:time
              }
            }
            this._companyService.sendNotificationToSomeoneElse(this.event,user,{uid:this._appData.instagramUser.uid,full_name:this._appData.instagramUser.full_name},'Notificação',text,'text','success',true)
        }
        })
    }
}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/office-screens/office.component.ts